import { useEffect } from "react";
import { detectUserLocale, invalidateLocaleCache } from "../utils/multi-language";
import { useGlobalState } from "../GlobalStates";

export const useUserLocale = () => {
  const [language, setLanguage] = useGlobalState("language");
  const [community, setCommunity] = useGlobalState("community");
  const [currency, setCurrency] = useGlobalState("currency");
  const [localeLoading, setLocaleLoading] = useGlobalState("localeLoading");

  useEffect(() => {
    detectUserLocale().then(({ language, community, currency }) => {
      setLanguage(language);
      setCommunity(community);
      setCurrency(currency);
      setLocaleLoading(false);
    });
  }, []);

  const handleChangeLocale = ({ language, community, currency }) => {
    // The user is explicitly overriding locale — drop the memo so the axios
    // interceptors and any later detectUserLocale() reflect the new values
    // instead of serving the previously-resolved result.
    invalidateLocaleCache();
    if (language) {
      setLanguage(language);
      if (window.isInApp) {
        window.postMessage(`language:${language}`);
      } else {
        localStorage.setItem("language", language);
      }
    }
    if (community) {
      setCommunity(community);
      if (window.isInApp) {
        window.postMessage(`community:${community}`);
      } else {
        localStorage.setItem("community", community);
      }
    }
    if (currency) {
      setCurrency(currency);
      if (window.isInApp) {
        window.postMessage(`currency:${currency}`);
      } else {
        localStorage.setItem("currency", currency);
      }
    }
  };

  return {
    language,
    community,
    currency,
    loading: localeLoading,
    handleChangeLocale,
  };
};
